import {
  Directive, ContentChildren, Input, HostBinding, OnInit
  , QueryList, AfterContentInit, Output, EventEmitter
} from '@angular/core';
import { AccordionElementHeaderDirective } from './accordion-element-header.directive';
import { AccordionElementBodyComponent } from './accordion-element-body.component';
import { AccordionElementTriggerDirective } from './accordion-element-trigger.directive';

@Directive({
  selector: '[appAccordionElement]'
})
export class AccordionElementDirective implements OnInit, AfterContentInit {

  @HostBinding('class') class = 'card rounded-0';

  @HostBinding('style.overflow') style = 'visible';

  @ContentChildren(AccordionElementHeaderDirective) header: AccordionElementHeaderDirective;

  @ContentChildren(AccordionElementTriggerDirective, { descendants: true }) triggers: QueryList<AccordionElementTriggerDirective>;

  @ContentChildren(AccordionElementBodyComponent) body: QueryList<AccordionElementBodyComponent>;

  @Input() id: string;

  @Input() expanded: boolean;

  @Output() triggerClick = new EventEmitter<string>();

  @Output() collapsedChanged = new EventEmitter<{id: string, isExpanded: boolean}>();

  _expanded: boolean;

  isWired: boolean;

  constructor() { }

  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  ngAfterContentInit(): void {
    // wire triggers if they change
    this.wireTriggers();

    this.setExpanded(this.expanded);
  }

  /**
   * Setup of triggers
   *
   * @memberof ClxAccordionComponent
   */
  wireTriggers() {
    if (!this.isWired) {
      this.isWired = true;
      this.triggers.forEach(t => {
        t.buttonClick.subscribe(() => this.triggerClick.emit(this.id));
      });
    }
  }

  toggle() {
    this._expanded = !this._expanded;
    this.body.forEach(t => {
      t.setState(this._expanded);
      this.collapsedChanged.emit({ id: this.id, isExpanded: this._expanded });
    });
  }

  setExpanded(expanded: boolean) {
    if (this._expanded !== expanded) {
      this.toggle();
    }
  }

}
